/**
 * Bridge to access the current language from non-React code (e.g. tRPC link error callbacks).
 *
 * The effective language lives in React context (useLanguage / useTranslate). Code outside the
 * React tree cannot call hooks, so we cannot use useTranslate there. This module uses a React
 * component to copy the context value into a module-level ref. Non-React code can then read the
 * language and pass it to the plain translate(key, language) from @orus.eu/translations.
 *
 * Use this ref only when you cannot use the useTranslate or useLanguage hooks (e.g. callbacks,
 * links, plain functions). Prefer useTranslate() whenever you are inside a React component.
 */
import { useEffect } from 'react'

import { useLanguage } from '@orus.eu/pharaoh'
import type { Language } from '@orus.eu/translations'

/** Use only when you cannot call useTranslate (e.g. tRPC links, non-React callbacks). Read language, then use translate(key, language). */
export const currentLanguageForNotificationsRef: { current: Language } = { current: 'fr' }

export function CurrentLanguageSyncForNotifications(): null {
  const language = useLanguage()
  useEffect(() => {
    currentLanguageForNotificationsRef.current = language
  }, [language])
  return null
}
